<template>
  <span
    class="input__icon icon icon--eye"
    tabindex="-1"
    @click="maskPasswordToggle"
  ></span>
</template>

<script>
export default {
  name: 'MaskPasswordToggle',
  methods: {
    maskPasswordToggle($event) {
      let unmaskBtn = $event.currentTarget,
        inputEl = unmaskBtn.previousSibling || unmaskBtn.nextSibling;

      if (inputEl.getAttribute('type') === 'password') {
        this.changeInputType(inputEl, 'text');
        unmaskBtn.classList.remove('icon--eye');
        unmaskBtn.classList.add('icon--closed-eye');
      } else {
        this.changeInputType(inputEl, 'password');
        unmaskBtn.classList.remove('icon--closed-eye');
        unmaskBtn.classList.add('icon--eye');
      }

      return false;
    },
    changeInputType: function(x, typeStr) {
      if (x.type === typeStr) {
        return x;
      }

      return (x.type = typeStr);
    }
  }
};
</script>
